export function formatToAlertType(text?: string): 'error' | 'warning' | 'success' {
    if (text === 'error') return 'error';
    if (text === 'success') return 'success';
    if (text === 'warning') return 'warning';
    return 'success';
}
